import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'

// Internal components
import Svg from '../Svg/Svg'
import { useContext, useEffect, useState } from 'react'
import { useMatchLog } from '@/root/context/MatchContext'
import { UserContext } from '../../context/UserContext'

const CalendarMatchInfo = (props) => {
  const { event } = props

  const userContext = useContext(UserContext)
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const MatchState = useMatchLog()

  const homeTeam = event.matchAway ? event.opponent : event.teamName
  const visitorTeam = event.matchAway ? event.teamName : event.opponent

  const [homeScore, setHomeScore] = useState(event.matchAway ? event.matchScore[0].opponent : event.matchScore[0].team)
  const [visitorScore, setVisitorScore] = useState(
    event.matchAway ? event.matchScore[0].team : event.matchScore[0].opponent
  )
  const today = new Date()
  const [isMatchDay, setIsMatchDay] = useState(new Date(event.matchDay).toDateString() === today.toDateString())

  useEffect(() => {
    if (event.uid && event.matchStatus !== 'ended') {
      const local = JSON.parse(localStorage?.getItem(`${event.uid}`))
      if (local?.score) {
        setHomeScore(event?.matchAway ? local?.score.opponent : local?.score.team)
        setVisitorScore(event?.matchAway ? local?.score.team : local?.score.opponent)
      }
      if (local?.matchDay) {
        setIsMatchDay(new Date(local?.matchDay).toDateString() === today.toDateString())
      }
    }
  }, [MatchState])

  return (
    <div className={`CalendarMatchInfo`}>
      <h2 className="CalendarCard-category">{t(`CALENDAR_MATCHINFO__${event.matchType.toUpperCase()}`)}</h2>
      <div className="CalendarMatchInfo-matchStatus">
        <div className="CalendarMatchInfo-matchStatusColumn">
          <span className={`CalendarMatchInfo-homeTeam ${event.matchAway ? '' : 'is-self'}`}>{homeTeam}</span>
          <span className={`CalendarMatchInfo-visitorTeam ${event.matchAway ? 'is-self' : ''}`}>{visitorTeam}</span>
        </div>
        <div className="CalendarMatchInfo-matchStatusColumn">
          {event.matchStatus === 'start' && (
            <>
              <span className="CalendarMatchInfo-time"> {event.matchTime}</span>
              <span className="CalendarMatchInfo-location">
                {event.matchAway ? t('MDL__LBL_AWAY') : t('MDL__LBL_HOME')}
              </span>
            </>
          )}
          {event.matchStatus === 'ongoing' && (
            <>
              <span className="CalendarMatchInfo-live">
                {isMatchDay ? (
                  <>
                    <Svg id="icon-live" modifiers={['CalendarMatchInfo-icon']} /> Live
                  </>
                ) : (
                  <>
                    <Svg id="icon-exclamation" modifiers={['CalendarMatchInfo-icon']} />
                    {t('PROPERTYBLOCK__UNFINISHED_MATCH')}
                  </>
                )}
              </span>
              <span className="CalendarMatchInfo-score">
                <span className={`${event.matchAway ? '' : 'is-self'}`}>{homeScore || 0}</span>
                <span> - </span>
                <span className={`${event.matchAway ? 'is-self' : ''}`}>{visitorScore || 0}</span>
              </span>
            </>
          )}
          {event.matchStatus === 'ended' && (
            <>
              <span className={`CalendarMatchInfo-score ${event.matchAway ? '' : 'is-self'}`}>{homeScore || 0}</span>
              <span className={`CalendarMatchInfo-score ${event.matchAway ? 'is-self' : ''}`}>{visitorScore || 0}</span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

CalendarMatchInfo.defaultPropTypes = {
  event: {}
}
CalendarMatchInfo.propTypes = {
  event: PropTypes.object
}

export default CalendarMatchInfo
